import BaseSelect from "./base-select";
import {ActionTypeEnum} from "../../base/training-literals";

class MediaScreenSelect extends BaseSelect {
    constructor(props = {}) {
        super (props);
        this.actionType = ActionTypeEnum.MEDIA_SCREEN_SELECT;
    }

    get(props = {}) {
        return {
            type: this.actionType,
            timelineMap: props.timelineMap || this.timelineMap,
            duration: props.duration || this.until
        }
    }
}

export default MediaScreenSelect;